import * as React from 'react';
import {cn} from '../../lib/cn';
import {VisualCheckbox} from './VisualCheckbox';

type SelectAllRowProps = {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onToggle: () => void;
};

function SelectAllRow({label, checked, disabled, onToggle}: SelectAllRowProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      className={cn(
        'flex w-full items-center gap-3 border-0 border-b border-[#f2f4f8] bg-white px-4 py-[14px] text-left text-[16px] font-bold leading-5 text-[var(--chekin-color-brand-navy)] outline-none transition-colors hover:bg-[var(--chekin-color-surface-pressed)]',
        disabled && 'cursor-default opacity-40',
      )}
    >
      <VisualCheckbox checked={checked} disabled={disabled} />
      <span className="flex-1">{label}</span>
    </button>
  );
}

export {SelectAllRow};
export type {SelectAllRowProps};
